import React, {useEffect, useState} from 'react';
import {AdminHeader, Users} from "./";
import {Container, Row, Col, Card, CardBody, CardHeader} from "reactstrap";
import { default as useUserStore } from "../hooks/useUserStore";
import {ui_helpers} from "../helpers";
import {Redirect} from "react-router-dom";

export default function UserAdmin(props) {
  const [redirect, setRedirect] = useState('');
  const currentUser = useUserStore(x => x.currentUser);

  useEffect(() => {
    if(ui_helpers.isSystemAdministrator(currentUser) || ui_helpers.isAnyCompanyAdministrator(currentUser)) return;
    setRedirect('/');
  }, [currentUser]);

   if (redirect) {
     return (<Redirect to={redirect}/>);
   }
  return (<>
      <AdminHeader users/>
      <Container fluid>
          <Users/>
      </Container>
  </>)

}